export const TITLE_POSITION_VALUES = {
  CENTER: 1,
  BOTTOM: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/title-position-values.js